module.exports = __webpack_public_path__ + "static/media/ps.c3336467.png";